// extracted by mini-css-extract-plugin
export default {"total":"TotalCart_total__X0Nsj","show":"TotalCart_show__undeI","active":"TotalCart_active__DAL1B","bottom":"TotalCart_bottom__z+Nhm"};